import { useUrlGenerator } from '@folklore/routes';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import PageMeta from '../../partials/PageMeta';
import Text from '../../typography/Text';
import Title from '../../typography/Title';

import styles from '../../../../styles/pages/auth.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function EmailConfirmed({ page = null }) {
    const route = useUrlGenerator();
    const { title = null } = page || {};
    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Title className={styles.title} size="mediumLarge">
                {title || (
                    <FormattedMessage defaultMessage="Email confirmed" description="Page title" />
                )}
            </Title>
            <Text className={styles.text}>
                <FormattedMessage defaultMessage="Thank you!" description="Page description" />
            </Text>
            <p className={styles.notice}>
                <Link className={styles.helpLink} href={route('home')}>
                    <FormattedMessage defaultMessage="Go to home page" description="Button label" />
                </Link>
            </p>
        </div>
    );
}

EmailConfirmed.propTypes = propTypes;

export default EmailConfirmed;
